var _path, _path2, _path3, _circle, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _rect2, _path0, _path1, _path10, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 364,
    height: 168,
    viewBox: "0 0 364 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.4 52.7817C110.4 52.8417 109.47 52.4617 107.76 52.0817C105.345 51.5598 102.858 51.465 100.41 51.8017C96.7785 52.2819 93.3515 53.76 90.51 56.0717C87.0238 58.9093 84.5648 62.8122 83.51 67.1817V67.3017L83.31 68.0917L83 67.3417C81.2982 63.2019 78.3794 59.6763 74.63 57.2317C71.5703 55.2413 68.0519 54.0673 64.41 53.8217C61.9531 53.6487 59.4845 53.875 57.1 54.4917C55.41 54.9417 54.52 55.3317 54.5 55.2817C54.7045 55.161 54.9185 55.0574 55.14 54.9717C55.7609 54.7029 56.3989 54.4758 57.05 54.2917C60.0342 53.4205 63.1698 53.1956 66.2478 53.6318C69.3258 54.0681 72.2754 55.1556 74.9 56.8217C78.755 59.3009 81.7566 62.9029 83.5 67.1417H82.99V67.0217C84.0713 62.5393 86.6066 58.5412 90.2 55.6517C93.1217 53.3146 96.643 51.8486 100.36 51.4217C102.85 51.1088 105.376 51.2614 107.81 51.8717C108.47 52.0328 109.119 52.24 109.75 52.4917C109.973 52.5743 110.19 52.6711 110.4 52.7817Z",
    fill: "#006FD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M314.63 21.5397C314.63 21.5397 314.191 21.2274 313.38 20.7126C312.237 20.0066 310.982 19.5007 309.669 19.2166C307.719 18.7817 305.687 18.8945 303.798 19.5425C301.485 20.3355 299.494 21.8623 298.129 23.8906L298.108 23.9469L297.642 24.6272L297.622 23.8196C297.539 21.3796 296.719 19.0218 295.269 17.0572C294.083 15.4586 292.512 14.1854 290.703 13.3553C289.481 12.7898 288.176 12.4239 286.838 12.2717C285.895 12.167 285.357 12.1803 285.352 12.1359C285.347 12.0914 285.487 12.0898 285.741 12.0668C286.113 12.0384 286.488 12.0384 286.861 12.0668C288.581 12.1661 290.259 12.6378 291.779 13.4493C293.3 14.2608 294.625 15.3927 295.665 16.7669C297.202 18.7983 298.071 21.2567 298.151 23.8028L297.673 23.6252L297.697 23.5596C299.123 21.4345 301.215 19.8437 303.644 19.0374C305.291 18.4981 307.041 18.3503 308.756 18.6057C310.47 18.8611 312.101 19.5126 313.52 20.5085C313.825 20.7244 314.115 20.9604 314.388 21.2151C314.487 21.308 314.569 21.4179 314.63 21.5397Z",
    fill: "#006FD6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M135.84 0.00177917C135.84 0.00177917 135.34 0.57177 134.43 1.60177C133.154 3.0542 132 4.60949 130.98 6.25178C127.592 11.7037 125.817 18.0032 125.86 24.4218V24.6518H125.32C124.799 21.2133 123.678 17.893 122.01 14.8418C120.67 12.3462 118.987 10.0506 117.01 8.02178C115.671 6.65225 114.208 5.41022 112.64 4.31178C111.52 3.54178 110.88 3.15178 110.9 3.11178C111.077 3.16221 111.246 3.23979 111.4 3.34178C111.71 3.53178 112.19 3.75178 112.75 4.14178C114.385 5.1795 115.903 6.38977 117.28 7.75178C119.338 9.77211 121.092 12.0793 122.49 14.6018C124.218 17.7034 125.373 21.0908 125.9 24.6018H125.37V24.4218C125.328 17.9191 127.183 11.5454 130.71 6.08178C131.763 4.43658 132.975 2.89915 134.33 1.49178C134.79 0.981785 135.21 0.631784 135.47 0.381784C135.73 0.131784 135.83 -0.0182208 135.84 0.00177917Z",
    fill: "#006FD6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 181.641,
    cy: 53.5,
    r: 18.5,
    fill: "url(#paint0_radial_128_9159)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M133.528 63.2632L157.828 33.6787C158.136 33.3045 158.742 33.542 158.714 34.0254L156.893 64.9342C156.877 65.2099 156.64 65.4202 156.364 65.404L133.885 64.0797C133.477 64.0557 133.269 63.579 133.528 63.2632Z",
    fill: "#006FD6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M200.718 64.2059L223.236 33.2435C223.521 32.8519 224.141 33.0534 224.141 33.5376V64.5C224.141 64.7761 223.917 65 223.641 65H201.123C200.714 65 200.478 64.5364 200.718 64.2059Z",
    fill: "#006FD6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M129.309 77.4334C128.854 76.7463 129.379 75.8348 130.202 75.8832L167.138 78.0591C167.96 78.1076 168.374 79.0744 167.842 79.7034L159.767 89.245C159.564 89.4853 159.259 89.6158 158.945 89.5973L136.983 88.3035C136.669 88.285 136.382 88.1197 136.208 87.8572L129.309 77.4334Z",
    fill: "#E7F1FB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M197.341 78.6C196.846 77.9408 197.317 77 198.141 77H235.141C235.965 77 236.435 77.9408 235.941 78.6L228.441 88.6C228.252 88.8518 227.955 89 227.641 89H205.641C205.326 89 205.029 88.8518 204.841 88.6L197.341 78.6Z",
    fill: "#E7F1FB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 87C0.5 87 28.9521 77 47.811 77C66.6699 77 76.2631 87 95.122 87C113.981 87 123.574 77 142.433 77C161.292 77 170.885 87 189.744 87C208.603 87 218.196 77 237.055 77C255.914 77 265.507 87 284.366 87C303.225 87 312.818 77 331.677 77C350.536 77 363.5 87 363.5 87V157H0.5V87Z",
    fill: "#F9FCFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 104C0.5 104 13.4641 94 32.323 94C51.1819 94 60.7751 104 79.634 104C98.4929 104 108.086 94 126.945 94C145.804 94 155.397 104 174.256 104C193.115 104 202.708 94 221.567 94C240.426 94 250.019 104 268.878 104C287.737 104 297.33 94 316.189 94C335.048 94 363.5 104 363.5 104V161H0.5V104Z",
    fill: "#F0F8FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 154.279,
    y: 58.2695,
    width: 3,
    height: 19,
    transform: "rotate(3.37137 154.279 58.2695)",
    fill: "#006FD6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 221.141,
    y: 58,
    width: 3,
    height: 19,
    fill: "#006FD6"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 167L362.5 167",
    stroke: "#006FD6",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4552 127C64.5424 126.99 73.7431 117 91.8302 117C109.917 117 119.118 127 137.205 127C155.292 127 164.493 117 182.58 117C200.667 117 209.868 127 227.955 127C246.042 127 255.243 117 273.33 117C291.417 117 300.618 127 318.705 127C336.792 127 345.413 117 363.5 117V167H348.646H38.0997H17.6752H0.5V117C18.6315 117 28.3237 127.01 46.4552 127Z",
    fill: "#E2F1FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M335.5 80L363.5 86.5V167H335.5V80Z",
    fill: "url(#paint1_linear_128_9159)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 167L0.500008 167L0.500008 87L26.5 80L26.5 167Z",
    fill: "url(#paint2_linear_128_9159)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_128_9159",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(181.641 53.5) rotate(90) scale(18.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.572408,
    stopColor: "#99C5EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945308,
    stopColor: "#99C5EF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_128_9159",
    x1: 363.5,
    y1: 121,
    x2: 335.523,
    y2: 122.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_128_9159",
    x1: 0.500004,
    y1: 126,
    x2: 26.4843,
    y2: 125.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.1bb413185b7300c07dbbaf135de72742.svg";
export { ForwardRef as ReactComponent };